import { useRouter } from 'next/router';
import { useState } from 'react';
import { createPortal } from 'react-dom';
import css from './index.module.scss';
import { wintextObj } from './wintext';
import QuoteForm from './QuoteForm';

export default function QuoteWinIn({ callback, className }: any) {
    const [stepVal, setStepVal] = useState('a1');
    const { locale, query, pathname } = useRouter();
    const wintext = wintextObj[locale as any] || wintextObj['us'];
    const isCostco = query.source === 'costco';
    const isShopify = query.source === 'Shopify';
    const THEME_WHITE = ['/ef-quote-form', '/delta-pro-3-portable-power-station', '/calculators/delta-pro-ultra', '/power-preparedness'];
    const theme = THEME_WHITE.includes(pathname) ? 'white' : 'black';
    const IS_QUOTE_FORM = pathname === '/ef-quote-form';

    // 关闭
    const closeHandle = () => {
        callback && callback('close');
        if (IS_QUOTE_FORM) {
            setStepVal('a1');
        }
    };

    // 成功回调
    const successCallback = () => {
        setStepVal('a2');
    };

    const successTips = (
        <div className={`win-container win-container-quote-success ${isCostco || isShopify ? 'is-costco' : ''}`}>
            <span className="win-close" onClick={closeHandle}>
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <g id="system/line/cancel">
                        <path
                            id="Combined-Shape"
                            d="M6 5L19 18M19 5L6 18"
                            stroke="currentColor"
                            strokeWidth="1.8"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                        />
                    </g>
                </svg>
            </span>
            <div className="win-mainer win-mainer-quote-success">
                <div className="win-success-title">
                    <svg xmlns="http://www.w3.org/2000/svg" width="36" height="36" viewBox="0 0 36 36" fill="none">
                        <path
                            fillRule="evenodd"
                            clipRule="evenodd"
                            d="M33 18C33 26.2843 26.2843 33 18 33C9.71573 33 3 26.2843 3 18C3 9.71573 9.71573 3 18 3C26.2843 3 33 9.71573 33 18ZM23.9062 12.5303C24.1991 12.2374 24.674 12.2374 24.9669 12.5303L26.0275 13.591C26.3204 13.8839 26.3204 14.3588 26.0275 14.6517L16.4816 24.1976C16.4005 24.2787 16.3054 24.3374 16.2041 24.3735L16.1732 24.4045C15.8803 24.6974 15.4054 24.6974 15.1125 24.4045L9.53081 18.8228C9.23792 18.5299 9.23792 18.055 9.53081 17.7621L10.5915 16.7015C10.8844 16.4086 11.3592 16.4086 11.6521 16.7015L15.6936 20.7429L23.9062 12.5303Z"
                            fill="#30BF00"
                        />
                    </svg>
                    <span>{wintext.win_quote_success1}</span>
                </div>
                <div className="win-success-desc">{wintext.win_quote_success2}</div>
            </div>
        </div>
    );

    return (
        <div className={`${css.VoucherWin} ${className} theme-${theme}`}>
            {stepVal === 'a1' && (
                <div className="win-container win-container-quote">
                    <div className="win-header">
                        {wintext.win_quote_float}
                        <span className="win-close" onClick={closeHandle}>
                            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <g id="system/line/cancel">
                                    <path
                                        id="Combined-Shape"
                                        d="M6 5L19 18M19 5L6 18"
                                        stroke="currentColor"
                                        strokeWidth="1.8"
                                        strokeLinecap="round"
                                        strokeLinejoin="round"
                                    />
                                </g>
                            </svg>
                        </span>
                    </div>
                    <div className="win-mainer scrollbar-editor-black">
                        <div className="win-title win-title2">
                            {wintext.win_quote_title}
                            <a href="tel:+1(800)-366-8604">{wintext.win_quote_title2}</a>
                        </div>
                        <QuoteForm callback={successCallback} />
                        <div className="win-form-footer">
                            {wintext.win_quote_f1}
                            <a href="facetime:+1(800)-368-8604">{wintext.win_quote_f2}</a>
                        </div>
                    </div>
                </div>
            )}
            {stepVal === 'a2' && !IS_QUOTE_FORM && successTips}
            {stepVal === 'a2' && IS_QUOTE_FORM && createPortal(<div className={`${css.VoucherWin} theme-${theme}`}>{successTips}</div>, (document as any).body)}
        </div>
    );
}
